module.exports = "<div class=\"jsonFormCtrComp\" [formGroup]=\"_formParent\" *ngIf=\"_nodeName && jssTreeLeaf.visible\">\n\n   <mat-form-field class=\"jsonFormCtrComp__ctrl\">\n      <input matInput\n         [placeholder]=\"jssTreeLeaf.isRequired() ? _title + ' (*)' : _title\"\n         [formControlName]=\"_nodeName\"\n         [readonly]=\"readonly\">\n   </mat-form-field>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/core/json-form/material/number/number.component.html
// module id = ../../../../../src/app/core/json-form/material/number/number.component.html
// module chunks = main